<template>
  <div class="banners-wrap">
    <div class="banners-bg" v-show="imgShow">
      <img
        v-if="this.imgList.length < 1"
        src="../../static/webp2/banner@2x.webp"
        class="banner-bgs"
      />
      <Carousel
        v-else
        :autoplay="this.imgList.length > 1 ? true : false"
        :autoplay-speed="4000"
        loop
      >
        <CarouselItem v-for="(item, index) in imgList" :key="index">
          <img :src="item.image" class="banner-bgs" />
        </CarouselItem>
      </Carousel>
    </div>
    <div class="banners">
      <topS></topS>
      <div class="banners-title">简单、规范、智能</div>
      <div class="banners-search">
        请输入关键字
        <span class="search-icon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import topS from "../components/topS";
export default {
  components: {
    topS
  },
  data() {
    return {
      imgList: [],
      value: 0,
      imgShow: false
    };
  },
  mounted() {
    this.getImg();
  },
  methods: {
    getImg() {
      GMS.$http
        .get("/carousel/getCarousel")
        .then(res => {
          console.log("轮播图", res.data);
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].type == "two" && res.data[i].image) {
              this.imgList.push(res.data[i]);
            }
          }
          this.imgList = this.imgList.sort(this.sortby("ordina"));
          this.imgShow = true;
          console.log("第一版轮播图", this.imgList);
        })
        .catch(error => {
          this.imgShow = true;
          console.log("轮播图", error);
        });
    },
    sortby(prop, rev = true) {
      return function(a, b) {
        var val1 = a[prop];
        var val2 = b[prop];
        return rev ? val1 - val2 : val2 - val1;
      };
    }
  }
};
</script>

<style lang="less" scoped>
.banners-wrap {
  width: 100%;
  height: 715px;
  position: relative;
  overflow: hidden;
  .banners-bg {
    //background: #fff none no-repeat center center;
    //-webkit-background-size: cover;
    //-moz-background-size: cover;
    //-o-background-size: cover;
    //background-size: cover;
    //background-image:url('../../static/webp2/banner@2x.webp');
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: -1;
  }
  .banner-bgs {
    object-fit: cover;
    width: 100%;
    height: 715px;
  }
  .banners-title {
    width: 500px;
    height: 70px;
    font-family: FZFYSJW--GB1-0;
    font-weight: 0;
    font-size: 60px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: right;
    margin: 0 auto;
    margin-top: 100px;
    margin-bottom: 30px;
    text-align: center;
  }
  .banners-search {
    width: 500px;
    height: 36px;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.36);
    border-radius: 18px;
    margin: 0 auto;
    line-height: 36px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    letter-spacing: -0.15px;
    text-indent: 10px;
    backdrop-filter: blur(10px);
    // filter: blur(1px);
  }
  .search-icon {
    float: right;
    width: 16px;
    height: 16px;
    background: url("../../static/webp2/搜索@2x.webp");
    background-size: 16px 16px;
    margin-top: 10px;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bannerS.vue